import { appConfig } from "@/app/app-config";
import { useStore } from "@/state/legacy_module_api";
import {
  configure as configureWebSocket,
  connect as connectWebSocket,
  disconnect as disconnectWebSocket,
  isConnected,
  setHandlers,
} from "@/transport/webSocketService";
import {
  connectionEvent,
  connectionOpenEvent,
  disconnectedEvent,
  disconnectEvent,
} from "@/transport/websocket_events";
import * as threadService from "@/services/threadService";

let realtime_bootstrapped = false;

export async function bootRealtime(token?: string): Promise<void> {
  const store = useStore.getState();
  console.info("[bootstrap/realtime] bootRealtime", {
    tokenPrefix: token?.slice(0, 12) || null,
    storeTokenPrefix: store.apiToken?.slice(0, 12) || null,
    realtime_bootstrapped,
  });
  if (token !== undefined && store.apiToken != null && token !== store.apiToken) {
    console.debug("[bootstrap/realtime] ignoring stale token argument");
  }

  const api_token = store.apiToken ?? token;

  if (!api_token) {
    if (realtime_bootstrapped) {
      console.info("[bootstrap/realtime] no token, disconnecting existing websocket");
      disconnectWebSocket();
    }
    return;
  }

  setHandlers({
    onRaw: (evt) => {
      if (evt.type === connectionEvent || evt.type === connectionOpenEvent) {
        store.setWsConnected(true);
      }
      if (evt.type === disconnectedEvent || evt.type === disconnectEvent) {
        store.setWsConnected(false);
      }
    },
  });

  try {
    // Persist incoming websocket messages even before thread UI mounts.
    await threadService.init();
    console.info("[bootstrap/realtime] configuring websocket", {
      tokenPrefix: api_token.slice(0, 12),
      url: appConfig.websocketUrl,
    });
    await configureWebSocket(api_token, appConfig.websocketUrl);
    await connectWebSocket(api_token, appConfig.websocketUrl);
    store.setWsConnected(isConnected());
    realtime_bootstrapped = true;
  } catch (err) {
    console.error("[bootstrap/realtime] ws connect failed", err);
  }
}
